module.exports = __webpack_public_path__ + "img/case-type-arrow.1e6d196b.svg";